import { render, staticRenderFns } from "./payment-term.vue?vue&type=template&id=b223b3ca&"
import script from "./payment-term.vue?vue&type=script&lang=js&"
export * from "./payment-term.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports